import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { ISetSocialLibraryMinClipsV1Request } from './set-social-library-min-clips-v1-request';
import type { ISetSocialLibraryMinClipsV1Response } from './set-social-library-min-clips-v1-response';
import { setSocialLibraryMinClipsV1ResponseSchema } from './set-social-library-min-clips-v1-response';

export async function setSocialLibraryMinClipsV1Api(
  body: ISetSocialLibraryMinClipsV1Request,
): Promise<IValidatedResponse<ISetSocialLibraryMinClipsV1Response>> {
  return putRequest<ISetSocialLibraryMinClipsV1Response>({
    path: '/sys/social/v1/library/min-clips',
    body,
    schema: setSocialLibraryMinClipsV1ResponseSchema,
  });
}
